import React, {Component} from 'react';
import Popup from "reactjs-popup";
import popupStyles from "../../../../../../utils/popupConfig";

export default class TestOptionInput extends Component {
    constructor(props) {
        super(props);
        const value = sessionStorage.getItem(props.name);
        if (JSON.parse(value)) {
            this.state = JSON.parse(value);
            this.props.handleValueChange(this.props.name, this.state.inputValue);
        } else {
            this.state = {
                checked: false,
                inputValue: ''
            };
        }

        this.onCheck = this.onCheck.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
    }

    onCheck() {
        this.setState((prevState) => ({
            checked: !prevState.checked,
            inputValue: ''
        }), () => sessionStorage.setItem(this.props.name, JSON.stringify(this.state)));
        this.props.handleValueChange(this.props.name, '');
    }

    onInputChange(e) {
        const value = e.target.value || "";
        this.setState({
            inputValue: value
        }, () => sessionStorage.setItem(this.props.name, JSON.stringify(this.state)));
        this.props.handleValueChange(this.props.name, value);
    }

    render() {
        return (
            <div className={"option-input " + (this.props.blue ? "blue" : "")}>
                <div className="title">
                    <input type="checkbox"
                           name={this.props.name}
                           className="checkbox"
                           checked={this.state.checked}
                           onChange={this.onCheck}/>
                    <label htmlFor={this.props.name}>{this.props.name}</label>
                </div>
                <div className={"option " + (this.state.checked ? "active" : "")}>
                    {this.props.type !== "select" ? (
                        this.props.contextProp ? (
                            <Popup className="context-popup"
                                   contentStyle={popupStyles.contentStyle}
                                   arrowStyle={popupStyles.arrowStyle}
                                   trigger={
                                       <input type={this.props.type} placeholder={this.props.name}
                                              disabled={!this.state.checked} onChange={this.onInputChange}
                                              value={this.state.inputValue}/>}
                                   position="bottom center"
                                   on="hover">Separate multiple values with escapable pipe (|)</Popup>
                        ) : (
                            <input type={this.props.type} placeholder={this.props.name}
                                   disabled={!this.state.checked} onChange={this.onInputChange}
                                   value={this.state.inputValue}/>
                        )

                    ) : (
                        <select onChange={this.onInputChange}>
                            {this.state.checked && this.props.options.map((option, index) => (
                                <option key={index}>{option}</option>
                            ))}
                        </select>
                    )}
                </div>
            </div>
        );
    }
}